import { patchDocumentsParticipantsCurrentSigningPeriod } from '../signing-period';

interface PutDocumentsParticipantsCurrentExpiryParam {
  documentId: string;
  datetime: string;
  workspaceId: string;
}

/**
 * PUT 현재 서명 순서 참여자들의 서명 만료일 변경
 *
 * @deprecated This API is forwarded. Due to the path is changed in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#119d9ec550194e43973981c7d4b97336
 */
export function putDocumentsParticipantsCurrentExpiry({
  documentId,
  datetime,
  workspaceId,
}: PutDocumentsParticipantsCurrentExpiryParam) {
  return patchDocumentsParticipantsCurrentSigningPeriod({
    documentId,
    to: datetime,
    workspaceId,
  });
}
